import React from 'react';
import {Anchor, NoDataMsg} from '@albert-io/atomic';

const ArchivedClassesEmptyState = () => (
  <NoDataMsg.Container className='teacher-classes__empty-state u-mar-t_5'>
    <NoDataMsg.Heading as='h1'>No archived classes</NoDataMsg.Heading>
    <NoDataMsg.Body className='u-mar-b_5'>
      Archiving allows you to reference past class data to analyze patterns from the past for future
      classes and is a best practice for recordkeeping.
      <br />
      <Anchor
        as='a'
        href='https://help.albert.io/en/articles/1885019-how-do-i-archive-or-unarchive-a-class'
        target='_blank'
      >
        Learn more about archiving.
      </Anchor>
    </NoDataMsg.Body>
  </NoDataMsg.Container>
);

export default ArchivedClassesEmptyState;
